import { Injectable, Optional } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth/auth-service';
import { routerUrlToAbsolute } from '../utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardKeycloak extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    @Optional() protected readonly keycloak: KeycloakService
  ) {
    super(router, keycloak);
  }

  public isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      return this.keycloak
        .login({
          redirectUri: routerUrlToAbsolute(state.url),
          locale: 'en'
        })
        .then(() => {
          return true;
        });
    }

    if (
      this.keycloak.isUserInRole(
        AuthService.neededRole,
        environment.OAUTH_CLIENT_ID
      )
    ) {
      return Promise.resolve(true);
    }

    return Promise.resolve(false);
  }
}
